
const baseGeneralnUrl = "General"

  const endpoints = {
   getNotificationList:`${baseGeneralnUrl}/GetNotificationList`,
   deleteListNotification:`${baseGeneralnUrl}/DeleteNotificationList`,
   allReadNotificationList:`${baseGeneralnUrl}/AllReadNotificationList`,
  };
  
  export default endpoints;